import { Controller } from '@hotwired/stimulus'
import { createDropdown, whenBootstrapReady } from '../helpers/bootstrap'

export default class extends Controller {
  connect() {
    this.shareButton = this.element
    this.unsubscribeBootstrap = whenBootstrapReady(() => {
      this.dropdownEl = createDropdown(this.shareButton)
    })

    this.initButton()
  }

  disconnect() {
    if (this.unsubscribeBootstrap) this.unsubscribeBootstrap()
  }

  initButton() {
    const shareData = {
      title: this.shareButton.getAttribute('data-share-title'),
      message: this.shareButton.getAttribute('data-share-message'),
      url: this.shareButton.getAttribute('data-share-url'),
    }

    this.shareButton.addEventListener('click', () => {
      if (navigator.share) {
        if (this.dropdownEl) this.dropdownEl.hide()
        navigator.share(shareData).catch(() => null)
      }
    })
  }
}
